<template>
    <div class="container">
        <div class="row">
            <div class="col-xl-4 col-12 mb-3">
                <div class="card">
                    <div class="card-header blue-gradient">Agrega un área</div>
                    <div class="card-body">
                        <div class="form-group">
                            <label for="name">Área</label>
                            <input type="text" class="form-control" placeholder="Nombre de la nueva área" v-model="zone.name">
                        </div>
                        <div class="form-group">
                            <label for="name">Organización</label>
                            <select class="form-control" name="" id="" v-model="zone.city_id">
                                <option v-for="city in cities" :value="city.id" :key="city.id">{{city.name}}</option>
                            </select>
                        </div>
                        <input class="btn btn-primary" type="button" value="Guardar" @click.prevent="storeZone">
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-12">
                <div class="card">
                    <div class="card-header green-gradient">Áreas creadas por organización</div>
                    <div class="card-body">
                        <table class="table table-stripped text-center" id="zones-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre</th>
                                    <th>Organización</th>
                                    <th>Borrar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(zone, i) in zones" :key="zone.id">
                                    <td>{{zone.id}}</td>
                                    <td>
                                        <input type="text" style="border-radius: 3px; border: none; border-bottom: 1px solid gray" v-model="zone.name">
                                        <input type="button" value="Guardar" class="ml-3 mb-1 btn btn-sm btn-warning" @click="updateZone(zone)">
                                    </td>
                                    <td>{{zone.city}}</td>
                                    <td width="50px"><input type="button" value="✕" class="btn btn-danger btn-sm" @click="deleteZone(zone, i)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'cities',
    mounted: function(){
        this.fetchCities();
        this.fetchZones();

    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            cities: [],
            zones: [],
            zone: {
                name: "",
                city_id: 0,
            },
            table: null
        }
    },
    methods: {
        fetchCities: function(){
            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/cities`)
            .then(data => {
                _this.cities = data.body.data;
            })
            .catch(error => {
                console.log(error.error);
            });
        },
        fetchZones: function(){
            let _this = this;
            let loader = this.$loading.show();
            this.$http.get(
                `${this.baseUrl}/admin/zones`, 
                {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                _this.zones = data.body.data;
                var zonesTable = $("#zones-table");
                window.setTimeout(()=>{this.renderTable(zonesTable)}, 0);
                loader.hide();

            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        storeZone: function(){
            if(this.zone.name != "" && this.zone.city_id != 0){
                let loader = this.$loading.show();
                this.$http.post(
                    `${this.baseUrl}/admin/zones`, this.zone,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                .then(data => {
                    console.log(data);
                    this.fetchZones();
                    loader.hide();
                    this.zone.name="";
                    this.zone.city_id=0;
                    window.location.reload();
                    
                })
                .catch(error => {
                    loader.hide();
                    this.$dialogs.alert("Ya existe un área con ese nombre en esa organización", {title: 'Error', size: 'sm'});
                    this.city="";

                });
            } else {
                this.$dialogs.alert("Se requiere el nombre del área y la organización", {title: 'Error', size: 'sm'});
            }
        },
        deleteZone(zone, i){
            this.$dialogs.confirm(`¿Desea borrar el área ${zone.name}?`, {title: "Eliminar", size: "sm", okLabel: "Sí", cancelLabel: "Cancelar"})
            .then(response => {
                if(response.ok){
                    const loader = this.$loading.show();
                    const requestUrl = `${this.baseUrl}/admin/zones/${zone.id}`;
                    this.$http.delete(requestUrl,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                    .then(data => {
                        this.$dialogs.alert("Área borrada con éxito", {title: "Éxito", size: "sm"});
                        this.zones.splice(i, 1);
                        loader.hide();
                    })
                    .catch(error => {
                        if(error.status == 409){
                            this.$dialogs.alert("No se puede eliminar el área, porque tiene dependencias asignadas", {title: "Error", size: "sm"});
                            loader.hide();
                        }
                    });
                }
            });
        },
        updateZone(zone){
            const loader = this.$loading.show();
            const requestUrl = `${this.baseUrl}/admin/zones/${zone.id}`;
            this.$http.put(requestUrl, zone,
            {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                this.$dialogs.alert("Área actualizada con éxito", {title: "Éxito", size: "sm"});
                loader.hide();
            })
            .catch(error => {
                if(error.status == 409){
                    loader.hide();
                    this.$dialogs.alert("No se puede actualizar el área ya que tiene dependencias o casos relacionados", {title: "Error", size: "sm"}).then(()=>{
                        window.location.reload();
                    });
                } else if(error.status == 422){
                    this.$dialogs.alert("Ya existe un área con ese nombre", {title: "Error", size: "sm"}).then(()=>{
                        window.location.reload();
                    });
                }
            })        },
        renderTable(table){
            if(this.table != null){
                this.table.destroy();
            }

            this.table = table.DataTable({
                destroy: true,
                "language": {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                }
            });
        }
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


